// 社区医院数据
export default {
  namespaced: true,
  state () {
    return {
      // 用户信息
      datas: [
        {
          id: '56',
          name: '宏乾健康',
          doctors: [
            {
              name: '',
              img: 'https://cdn.keihong.tech/img/202501101742042.png'
            },
            {
              name: '',
              img: 'https://cdn.keihong.tech/img/202501101742260.png'
            }
          ]
        },
        {
          id: '59',
          name: '霸桥区席王柴马社区卫生服务站',
          mainImg: 'https://cdn.keihong.tech/img/202412091556356.png',
          doctors: [
            {
              name: '',
              img: 'https://cdn.keihong.tech/img/202412091637331.png'
            },
            {
              name: '',
              img: 'https://cdn.keihong.tech/img/202412091639275.png'
            }
          ]
        },
        {
          id: '60',
          name: '瑞仁中医诊所',
          mainImg: 'https://cdn.keihong.tech/img/202412242135051.png',
          doctors: [
            {
              name: '',
              img: 'https://cdn.keihong.tech/img/202501110538970.jpg'
            },
            {
              name: '',
              img: 'https://cdn.keihong.tech/img/202501110539399.jpg'
            },
            {
              name: '',
              img: 'https://cdn.keihong.tech/img/202501110540199.jpg'
            },
            {
              name: '',
              img: 'https://cdn.keihong.tech/img/202501110540340.jpg'
            }
          ]
        },
        {
          id: '61',
          name: '内蒙古包头市东河区河东镇卫生院分院',
          mainImg: 'https://cdn.keihong.tech/img/202412252153436.png',
          doctors: [
            {
              name: '',
              img: 'https://cdn.keihong.tech/img/202412252207917.png'
            },
            {
              name: '',
              img: 'https://cdn.keihong.tech/img/202412252207133.png'
            }
          ]
        },
        {
          id: '62',
          name: '顺德区容桂花溪社区卫生服务站',
          mainImg: 'https://cdn.keihong.tech/img/202501031131164.png',
          doctors: [
            {
              name: '',
              img: 'https://cdn.keihong.tech/img/202501031210456.png'
            },
            {
              name: '',
              img: 'https://cdn.keihong.tech/img/202501052056343.png'
            },
            {
              name: '',
              img: 'https://cdn.keihong.tech/img/202501052057233.png'
            }
          ]
        },
        {
          id: '63',
          name: '院后通',
          mainImg: 'https://cdn.keihong.tech/img/202501080106843.png',
          doctors: [
            {
              name: '',
              img: 'https://cdn.keihong.tech/img/202501031210456.png'
            },
            {
              name: '',
              img: 'https://cdn.keihong.tech/img/202501052056343.png'
            },
            {
              name: '',
              img: 'https://cdn.keihong.tech/img/202501052057233.png'
            }
          ]
        },
        {
          id: '64',
          name: '惠州市康复医学会',
          mainImg: 'https://cdn.keihong.tech/img/202501080114634.png',
          doctors: [
            {
              name: '',
              img: 'https://cdn.keihong.tech/img/202501031210456.png'
            },
            {
              name: '',
              img: 'https://cdn.keihong.tech/img/202501052056343.png'
            },
            {
              name: '',
              img: 'https://cdn.keihong.tech/img/202501052057233.png'
            }
          ]
        }, {
          id: '65',
          name: '连云港众力达健康管理有限公司',
          mainImg: 'https://cdn.keihong.tech/202502081356814.png',
          doctors: [
            {
              name: '',
              img: 'https://cdn.keihong.tech/img/20250319132358490.png'
            }
          ]
        }, {
          id: '16',
          name: '广州中医药大学顺德医院',
          mainImg: 'https://cdn.keihong.tech/img/20250217045747819.png',
          doctors: [
            {
              name: '',
              img: 'https://cdn.keihong.tech/img/20250217051103621.png'
            },
            {
              name: '',
              img: 'https://cdn.keihong.tech/img/20250217050726947.png'
            },
            {
              name: '',
              img: 'https://cdn.keihong.tech/img/20250217050743285.png'
            }
          ]
        }, {
          id: '67',
          name: '汉古中医',
          mainImg: 'https://cdn.keihong.tech/img/20250324222448419.png',
          video: {
            url: 'https://cdn.keihong.tech/img/20250324195744666.mp4',
            cover: 'https://cdn.keihong.tech/img/20250324195744666.mp4?vframe/jpg/offset/1/w/960/h/720'
          },
          doctors: [
            {
              name: '',
              img: 'https://cdn.keihong.tech/img/20250324225536868.png'
            },
            {
              name: '',
              img: 'https://cdn.keihong.tech/img/20250324231440089.png'
            },
            {
              name: '',
              img: 'https://cdn.keihong.tech/img/20250324230159739.png'
            },
            {
              name: '',
              img: 'https://cdn.keihong.tech/img/20250324233107388.png'
            },
            {
              name: '',
              img: 'https://cdn.keihong.tech/img/20250324233338570.png'
            },
            {
              name: '',
              img: 'https://cdn.keihong.tech/img/20250324233429238.png'
            },
            {
              name: '',
              img: 'https://cdn.keihong.tech/img/20250324233459205.png'
            },
            {
              name: '',
              img: 'https://cdn.keihong.tech/img/20250324233537024.png'
            },
            {
              name: '',
              img: 'https://cdn.keihong.tech/img/20250324234633722.png'
            }
          ]
        }, {
          id: '57',
          name: '动龄健康',
          mainImg: 'https://cdn.keihong.tech/img/20250421141921616.png',
          introductionArticleId: 300,
          bannerList: [
            {
              title: '7天控糖体验营',
              img: 'https://cdn.keihong.tech/img/20250421152425083.png',
              articleId: 1
            },
            {
              title: '28天控糖脱药挑战营',
              img: 'https://cdn.keihong.tech/img/20250421152436253.png',
              articleId: 2
            },
            {
              title: '百日逆糖新生营',
              img: 'https://cdn.keihong.tech/img/20250421152504737.png',
              articleId: 3
            },
            //  居家主动康复指导服务、脑卒中防再梗服务、认知症高风险防治服务
            {
              title: '居家主动康复指导服务',
              img: 'https://cdn.keihong.tech/img/20250422171554389.png',
              articleId: 4
            },
            {
              title: '脑卒中防再梗服务',
              img: 'https://cdn.keihong.tech/img/20250422171603386.png',
              articleId: 5
            },
            {
              title: '认知症高风险防治服务',
              img: 'https://cdn.keihong.tech/img/20250422171610179.png',
              articleId: 6
            }
          ],
          // video: {
          //   url: 'https://cdn.keihong.tech/img/20250324195744666.mp4',
          //   cover: 'https://cdn.keihong.tech/img/20250324195744666.mp4?vframe/jpg/offset/1/w/960/h/720'
          // },
          doctors: [
            // {
            //   name: '',
            //   img: 'https://cdn.keihong.tech/img/20250421195451313.png'
            // }
          ]
        }, {
          id: '73',
          name: '大云山苦荞基地',
          mainImg: 'https://cdn.keihong.tech/img/20250421141921616.png',
          introductionArticleId: 300,
          bannerList: [
            {
              title: '7天控糖体验营',
              img: 'https://cdn.keihong.tech/img/20250421152425083.png',
              articleId: 1
            },
            {
              title: '28天控糖脱药挑战营',
              img: 'https://cdn.keihong.tech/img/20250421152436253.png',
              articleId: 2
            },
            {
              title: '百日逆糖新生营',
              img: 'https://cdn.keihong.tech/img/20250421152504737.png',
              articleId: 3
            },
            //  居家主动康复指导服务、脑卒中防再梗服务、认知症高风险防治服务
            {
              title: '居家主动康复指导服务',
              img: 'https://cdn.keihong.tech/img/20250422171554389.png',
              articleId: 4
            },
            {
              title: '脑卒中防再梗服务',
              img: 'https://cdn.keihong.tech/img/20250422171603386.png',
              articleId: 5
            },
            {
              title: '认知症高风险防治服务',
              img: 'https://cdn.keihong.tech/img/20250422171610179.png',
              articleId: 6
            }
          ],
          // video: {
          //   url: 'https://cdn.keihong.tech/img/20250324195744666.mp4',
          //   cover: 'https://cdn.keihong.tech/img/20250324195744666.mp4?vframe/jpg/offset/1/w/960/h/720'
          // },
          doctors: [
            // {
            //   name: '',
            //   img: 'https://cdn.keihong.tech/img/20250421195451313.png'
            // }
          ]
        }
      ]
    }
  },
  getters: {
    /**
     * 判断 qrCodeHospital 是否在 datas 数组中
     * @param {Object} state Vuex 的 state
     * @returns {Function} 一个接收 hospitalName 参数的函数，返回布尔值
     */
    isHospitalInList: (state) => (hospitalName) => {
      return state.datas.some((hospital) => hospital.name === hospitalName)
    }
  },
  mutations: {}
}
// ————————————————
// 版权声明：本文为CSDN博主「run-Ameng」的原创文章，遵循CC 4.0 BY-SA版权协议，转载请附上原文出处链接及本声明。
// 原文链接：https://blog.csdn.net/m0_58861443/article/details/120247013
